import { Controller } from "@hotwired/stimulus"
import { current } from "../helpers/current"

export default class extends Controller {
  static values = { username: String }

  connect() {
    if (this.usernameValue === current.account.username) {
      this.element.textContent = "you"
    }
  }
}
